import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface UseGetCommunityNewsSettingsProps {
  community_id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunityNewsSettings = async (ID: string) =>
  await axiosAuth.get(`${GET_COMMUNITIES}/${ID}/news-settings`);

const useGetCommunityNewsSettings = ({
  community_id,
  queryParams,
}: UseGetCommunityNewsSettingsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["community-news-settings", community_id],
    queryFn: () => getCommunityNewsSettings(community_id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetCommunityNewsSettings;
